export enum BlogCategory {
  Python = 'Python',
  JavaScript = 'JavaScript',
  HtmlCss = 'HTML/CSS',
  CSharp = 'CSharp',
  General = 'General'
}
